import Vue from 'vue';
import Vuex from 'vuex';
import { IAppState } from '@/store/Auth/AppModule';
import { DashboardState } from '@/store/Dashboard/DashboardModule';
import { IInstitutionAccountSettingsState } from '@/store/Accounts/InstitutionAccountSettingsModule';
import { IInstitutionAccountState } from '@/store/Accounts/InstitutionAccountModule';
import { IDepositAccountState } from '@/store/Accounts/DepositAccountModule';
import { ILendingAccountState } from '@/store/Accounts/LendingAccountModule';
import { ICustomerState } from '@/store/Customers/CustomerModule';
import { IOrganisationState } from '@/store/Customers/OrganisationModule';
import { IPersonState } from '@/store/Customers/PersonModule';
import { IProductWizardState } from '@/store/Products/ProductWizardModule';
import { IProductListState } from '@/store/Products/ProductListModule';
import { IProductDetailsState } from '@/store/Products/ProductDetailsModule';
import { IProductIssueListState } from '@/store/Products/ProductIssueListModule';
import { IProductIssueDetailsState } from '@/store/Products/ProductIssueDetailsModule';
import { IProductMigrationState } from '@/store/Products/ProductMigrationModule';
import { IReportsState } from '@/store/Reporting/ReportsModule';
import { IGeneralLedgerAccountsState } from '@/store/Accounting/GeneralLedgerAccountsModule';
import { IJournalEntriesState } from '@/store/Accounting/JournalEntriesModule';
import { IDepositAccountSettingsState } from '@/store/Accounts/DepositAccountSettingsModule';
import { IUsersState } from '@/store/Settings/UsersModule';
import { IRolesState } from '@/store/Settings/RolesModule';
import { IAppMediumsState } from '@/store/Settings/AppMediumsModule';
import { IInstitutionsState } from '@/store/Settings/InstitutionsModule';
import { IRegionsState } from '@/store/Settings/RegionsModule';
import { IWebhooksState } from '@/store/Settings/WebhooksModule';

Vue.use(Vuex)

export interface IRootState {
    AppState: IAppState
    DashboardState: DashboardState
    InstitutionAccountSettingsState: IInstitutionAccountSettingsState
    InsitutionAccountState: IInstitutionAccountState
    IDepositAccountState: IDepositAccountState
    IDepositAccountSettingsState: IDepositAccountSettingsState
    ILendingAccountState: ILendingAccountState
    ICustomerState: ICustomerState
    IOrganisationState: IOrganisationState
    IPersonState: IPersonState
    IProductWizardState: IProductWizardState
    IProductDetailsState: IProductDetailsState
    IProductListState: IProductListState
    IProductIssueDetailsState: IProductIssueDetailsState
    IProductIssueListState: IProductIssueListState
    IProductMigrationState: IProductMigrationState
    IReportsState: IReportsState
    IGeneralLedgerAccountsState: IGeneralLedgerAccountsState
    IJournalEntriesState: IJournalEntriesState
    UsersState: IUsersState
    RolesState: IRolesState
    AppMediumsState: IAppMediumsState
    InstitutionsState: IInstitutionsState
    RegionsState: IRegionsState
    WebhooksState: IWebhooksState
}

export default new Vuex.Store<IRootState>({})